﻿
import "bootstrap";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailFakturaPosition extends GuiDetailGeneric {

    constructor() {
        super("FakturaPosition");
    }
}
